/**
 * External Links Module
 *
 * Centralized utilities for handling external links across the app.
 *
 * @example
 * // Open Betty's WhatsApp
 * import { openBettyChat } from '@/shared/utils/externalLinks';
 * openBettyChat();
 *
 * @example
 * // Open Help Center
 * import { openHelpCenter } from '@/shared/utils/externalLinks';
 * openHelpCenter();
 *
 * @example
 * // Share on WhatsApp
 * import { shareOnPlatform } from '@/shared/utils/externalLinks';
 * shareOnPlatform('whatsapp', { url: 'https://...', text: 'Check this out!' });
 */

// Types
export type {
  ExternalLinkOptions,
  ExternalLinkTarget,
  ShareOptions,
  SocialPlatform,
} from './types';

// Handlers
export {
  openExternalLink,
  openWhatsApp,
  openBettyChat,
  openHelpCenter,
  openHelpArticle,
  shareOnPlatform,
  getExternalLinkProps,
} from './handlers';

// Constants (re-exported for convenience)
export {
  SUPPORT_CONTACTS,
  EXTERNAL_URLS,
  SOCIAL_PLATFORMS,
} from '@/shared/constants/externalLinks';
